// Vite injects only env vars prefixed with VITE_ into import.meta.env. The
// dashboard-fe needs the dashboard-api URL; backend-api isn't called
// from this SPA (users hit it directly with their API keys).
//
// Set in `.env.local` for dev, in Cloudflare Pages env for prod.
//
// Names mirror the server-side dashboard-api env:
//   VITE_DASH_URL      ↔ DASH_URL      (this SPA's own public origin)
//   VITE_DASH_API_URL  ↔ DASH_API_URL  (dashboard-api the SPA calls)

export const env = {
  dashApiUrl: (import.meta.env.VITE_DASH_API_URL ?? "http://localhost:3102").replace(/\/$/, ""),
  dashUrl:    (import.meta.env.VITE_DASH_URL ?? "http://localhost:3103").replace(/\/$/, ""),
};
